module.exports = __webpack_public_path__ + "img/cityPartner5.73335c87.png";